export const rawPhoneNumber = phone => phone.replace(/[()\s]/g, "");

/**
 * Normalizes phone number to digits only (removes all non-digit characters)
 * Useful for comparing phone numbers regardless of formatting
 *
 * @param {string} phone - Phone number (formatted or raw)
 * @returns {string} Phone number with only digits
 *
 * @example
 * normalizePhoneNumber("(555) 123-4567")  // Returns "5551234567"
 * normalizePhoneNumber("555-123-4567")    // Returns "5551234567"
 * normalizePhoneNumber("5551234567")      // Returns "5551234567"
 */
export const normalizePhoneNumber = phone => {
  if (!phone) return "";
  return phone.replace(/\D/g, "");
};

/**
 * Formats a phone number string into US phone number format.
 * Strips all non-numeric characters and formats the result as (XXX) XXX-XXXX.
 *
 * @param {string} input - The phone number string to format (can contain any characters)
 * @returns {string} The formatted phone number string
 *
 * @example
 * formatPhoneNumber("1234567890")        // Returns "(123) 456-7890"
 * formatPhoneNumber("123-456-7890")      // Returns "(123) 456-7890"
 * formatPhoneNumber("abc123def456ghi7890") // Returns "(123) 456-7890"
 * formatPhoneNumber("123")               // Returns "123"
 * formatPhoneNumber("12345678901")       // Returns "(123) 456-7890" (only first 10 digits used)
 */
export const formatPhoneNumber = input => {
  const cleanedInput = input.replace(/\D/g, "");
  let formatted = "";

  if (cleanedInput.length <= 3) {
    formatted = cleanedInput;
  } else if (cleanedInput.length <= 6) {
    formatted = `(${cleanedInput.slice(0, 3)}) ${cleanedInput.slice(3)}`;
  } else {
    formatted = `(${cleanedInput.slice(0, 3)}) ${cleanedInput.slice(3, 6)}-${cleanedInput.slice(6, 10)}`;
  }

  return formatted;
};
